module.exports = __webpack_public_path__ + "img/root1.2ea4be27.png";